import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { ID_PERFIL_ADMIN_EBP, ID_PERFIL_ADMIN_EMPRESA } from '../../constants/perfiles'
import { MAPA_PEDIDOS } from '../../helpers/filtros/mapaPedidos'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { adjuntoBuilder } from '../reutilizables/upload/adjuntoBuilder'
import { DescargarExcelVentas } from '../servicios/descargarExcel'

const CAMPOS_ARBOL = ['compradorEmpresa', 'compradorUsuario', 'vendedorEmpresa', 'vendedorUsuario']

const CAMPOS_PLANOS = ['comprador', 'vendedor']

const normalizar = (valor) => (valor === '' || valor === undefined || valor === null ? null : valor)

export const DescargarExcel = ({
  fechaDesde,
  fechaHasta,
  filtrosFijos,
  esAdministrador,
  esVentas
}) => {
  const { loginDataContext: { idUsuario, idPerfil, empid } = {}, esPerfilAdmin } = useAuth()
  const filtrosLocales = useSelector((state) => state.filters.filtrosLocales)
  const getFiltro = (titulo) => filtrosFijos.find((f) => f.titulo === titulo)?.value

  const camposEntidad = () => {
    const campos = {}

    CAMPOS_ARBOL.forEach((campo) => {
      const valor = normalizar(filtrosLocales[campo])
      if (valor !== null) {
        campos[MAPA_PEDIDOS[campo].campoExport({ esVentas })] = valor
      }
    })

    CAMPOS_PLANOS.forEach((campo) => {
      const destino = MAPA_PEDIDOS[campo].campoExport({ esVentas })
      if (campos[destino] !== undefined) {
        return
      }
      const valor = normalizar(getFiltro(MAPA_PEDIDOS[campo].titulo))
      if (valor !== null) {
        campos[destino] = valor
      }
    })

    return campos
  }

  const descargaExcel = async () => {
    try {
      const entidades = camposEntidad()

      const empidVendedorPropio =
        [ID_PERFIL_ADMIN_EBP, ID_PERFIL_ADMIN_EMPRESA].includes(idPerfil) && esVentas ? empid : null

      const body = {
        fechaDesde,
        fechaHasta,
        idVendedor: entidades.idVendedor ?? (esAdministrador || esPerfilAdmin ? null : idUsuario),
        comprador: entidades.comprador ?? null,
        empidVendedor: entidades.empidVendedor ?? null,
        empidComprador: entidades.empidComprador ?? null,
        estadoPago: normalizar(getFiltro(MAPA_PEDIDOS.idPagoEstado.titulo)),
        estadoEnvio: normalizar(getFiltro(MAPA_PEDIDOS.idPedidoItemEstado.titulo)),
        titulo: !esVentas ? 'Todas las Ventas EBM' : 'Mis Ventas',
        incluirAvisosPublicacion: !esVentas,
        ...(empidVendedorPropio && { empidPedido: empidVendedorPropio })
      }

      const { data: excel } = await DescargarExcelVentas(body)
      await adjuntoBuilder(excel, null, 'Pedidos', { isBase64: false })
    } catch (error) {
      const mensaje = `Ocurrió un error al descargar el Excel.`
      toastErrorLog(error, mensaje, 'Descarga de Excel')
    }
  }

  return (
    <button className="btn btn-info" onClick={() => descargaExcel()}>
      <i className="bi bi-file-earmark-excel me-2"></i>
      Descargar pedidos
    </button>
  )
}
DescargarExcel.propTypes = {
  fechaDesde: PropTypes.string,
  fechaHasta: PropTypes.string,
  filtrosFijos: PropTypes.arrayOf(
    PropTypes.shape({
      titulo: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ),
  esVentas: PropTypes.bool,
  esAdministrador: PropTypes.bool
}
